/**
 * Ícones dos módulos do QBRN Lab.
 *
 * Família própria de produtos perigosos, no mesmo viewBox (0 0 24 24) e com o
 * mesmo traço dos ícones da biblioteca (strokeWidth 1,75, currentColor, sem
 * preenchimento), para não se distinguirem em uso.
 */
import { IconeProprio, type PropsIcone } from './base'

/** Caminhão-tanque de perfil: cavalo, tanque cilíndrico e painel de segurança. */
export const IconeModuloCaminhao = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <rect x="8" y="6.5" width="13.5" height="8" rx="4" />
    <path d="M8 10.5H2.5V15h5.5" />
    <path d="M2.5 10.5l1.5-3h4" />
    <rect x="12.5" y="9" width="4.5" height="3" />
    <circle cx="5" cy="17" r="1.6" />
    <circle cx="15" cy="17" r="1.6" />
    <circle cx="19" cy="17" r="1.6" />
  </IconeProprio>
)

/** Bola de fogo sobre o tanque, com os anéis de distância no chão. */
export const IconeModuloBleve = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <path d="M12 3c2.8 2.4 4.5 4.6 4.5 7a4.5 4.5 0 0 1-9 0c0-1.3.6-2.6 1.6-3.7.3 1.2 1 2 1.9 2.2C10.5 6.5 11 4.6 12 3z" />
    <ellipse cx="12" cy="18.5" rx="4" ry="1.3" />
    <ellipse cx="12" cy="18.5" rx="9" ry="3" />
  </IconeProprio>
)

/** Pluma tóxica: fonte à esquerda abrindo a favor do vento, com isolinha. */
export const IconeModuloPluma = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <circle cx="4" cy="12" r="1.5" />
    <path d="M5.5 11.2C10 9.5 15 7 21 5.5" />
    <path d="M5.5 12.8C10 14.5 15 17 21 18.5" />
    <path d="M7 12c3.5-1 7-1.8 10.5-1.8 0 2.4 0 2.4 0 3.6C14 13.8 10.5 13 7 12z" />
  </IconeProprio>
)

/** Dois tanques ligados por mangote, com o aterramento no solo. */
export const IconeModuloTransbordo = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <rect x="1.5" y="6" width="8" height="6.5" rx="3.25" />
    <rect x="14.5" y="6" width="8" height="6.5" rx="3.25" />
    <path d="M5.5 12.5v2.5h13v-2.5" />
    <path d="M12 15v4" />
    <path d="M9.5 19h5M10.5 20.7h3" />
  </IconeProprio>
)

/** Mesa tática em vista superior: perímetro, fonte no centro e anel de zona. */
export const IconeModuloTabletop = (p: PropsIcone) => (
  <IconeProprio {...p}>
    <path d="M2.5 6.5V3.5h3" />
    <path d="M18.5 3.5h3v3" />
    <path d="M2.5 17.5v3h3" />
    <path d="M18.5 20.5h3v-3" />
    <circle cx="12" cy="12" r="6" strokeDasharray="2 2" />
    <rect x="10" y="9.5" width="4" height="5" rx="1" />
  </IconeProprio>
)
